import { axiosV1 } from 'interceptors/axios';

import { decryptResponse } from 'utils/token';

type GetCommunicationProps = {
  communicationId: string;
  signal?: AbortSignal;
};

export const getCommunication = async ({
  communicationId,
  signal,
}: GetCommunicationProps) => {
  const { data } = await axiosV1.get(`/comms/${communicationId}`);

  const decodedData = await decryptResponse(data);

  return decodedData;
};
